import React, { useState } from "react";
import { createPortal } from 'react-dom';
import * as S from './BookingDetailsMmtStyles'
import { CALL_DRIVER_CTA_CLICKED, CALL_HELPLINE_CTA_CLICKED, KIOSK_IMAGE_CLICKED, KIOSK_MAP_CLICKED_MMT } from "../../../../../utils/util-constants";
import { trackEvent, PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU } from "../../../../../config/omniMmt";
import TerminalsMmt from "../TerminalsMmt/TerminalsMmt";
import OwnerDetailsMmt from "../OwnerDetailsMmt/OwnerDetailsMmt";
import ButtonMmt from "../ButtonMmt/ButtonMmt";

const BookingDetailsMmt = ({
    data,
    driverNumber = '',
    helplineNumber = '',
    rightImg =''
}) => { 
    const [fullImgView, setFullImgView] = useState(false)
    const {
        otpTxt,
        ownerDetails,
        facilities,
        vehicleImg,
        vehicleNo,
        helplineNumberTxt,
        driverNumberTxt,
        guideSectionData,
        footerData,
        kioskMapUrl
    } = data || {};

    const otpSection = () => (
      <S.OtpSection>
        {otpTxt?.label1}
        {otpTxt?.value &&  (
          <S.Otp>
            {otpTxt?.value?.split('').map((digit, index) => (
              <S.OtpSpan key={index}>{digit}</S.OtpSpan>
            ))}
          </S.Otp>
        )}
          {otpTxt?.label2}
      </S.OtpSection>
    )

    const headerSection = () => (
      <S.HeaderSection>
        <S.HeaderTopSection>
          <div>
            {vehicleNo && <S.VehicleNo>{vehicleNo}</S.VehicleNo>}
            {ownerDetails && <OwnerDetailsMmt data={ownerDetails} />}
            {facilities && <S.Facilities>
              {facilities?.map((item, idx) => (
                <S.Facility>
                  {item?.img && <img src={item?.img}/>}
                  {item?.label}
                </S.Facility>
              ))}
            </S.Facilities>}
          </div>
            <S.VehicleImgView>
                {rightImg && 
                <S.VehicleLogoWrap>
                  <S.VehicleLogo src={rightImg} />
                </S.VehicleLogoWrap>}
                {vehicleImg && <S.VehicleImg src={vehicleImg} />}
            </S.VehicleImgView>
        </S.HeaderTopSection>
          {(driverNumber || helplineNumber) && <S.BtnsWpr>
              {helplineNumber && <ButtonMmt btnTxt={helplineNumberTxt} type={2} onClick={() => {
                trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU, CALL_HELPLINE_CTA_CLICKED)
              }} number ={helplineNumber} isCall={true}/>}
              {driverNumber && <ButtonMmt btnTxt={driverNumberTxt} type={1} onClick={() => {
               trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU, CALL_DRIVER_CTA_CLICKED)
              }} number = {driverNumber} isCall={true}/>}
          </S.BtnsWpr>}
      </S.HeaderSection>
    );

    const guideSection = () => (
      <S.GuideSection>
        {guideSectionData?.label && <S.Label>{guideSectionData?.label}</S.Label>}
        {guideSectionData?.subLabel?.map((label, index) => (
          <S.SubLabel key={index}>
            <span>{index + 1}.</span>
            {label}
          </S.SubLabel>
        ))}
        {guideSectionData?.listItems && <S.ListItems>
          {guideSectionData?.listItems?.map((item, idx) => (
            <S.ListItem key={item?.id} onClick={() => {
              if (item?.type === "map") {
                trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU, KIOSK_MAP_CLICKED_MMT)
     
                  Boolean(kioskMapUrl) && typeof window !== "undefined" ? window.open(kioskMapUrl, '_blank') : setFullImgView(item?.img);
              } else {
                trackEvent(PROVISIONAL_HOB_OVERLAY_PAGE_THANKYOU, KIOSK_IMAGE_CLICKED)
                setFullImgView(item?.img);
              }}} className={guideSectionData.listItems.length === 1 ? 'singleItem' : ''}>
              <img src={item?.img} alt={item?.label} className={guideSectionData.listItems.length === 1 ? 'singleItem' : ''}/>
              {item?.label && <span className="label">{item?.label}</span>}
            </S.ListItem>
          ))}
        </S.ListItems>}
      </S.GuideSection>
    );

  const imageView = () => {
    return (
      <div>
        {createPortal(
          <S.PBFullImageView>
            <S.ImageCrossIc onClick={()=>setFullImgView(false)}/>
            <div className="kiosk-image-view">
              <S.KioskImage src={fullImgView} />
            </div>
          </S.PBFullImageView>,
          document.body
        )}
      </div>
    )
  };

  return (
    <div className="bookingDetails">
      {fullImgView && imageView()}
      {otpSection()}
      <S.WhiteBox>
        {headerSection()}
        {guideSectionData && guideSection()}
        <TerminalsMmt data={footerData} />
      </S.WhiteBox>
    </div>
  );
};

export default BookingDetailsMmt;